import SetSchedule from './SetSchedule';

/**
 * The client's own switch for automatic re-checks (D-30), for the question set
 * this run asked.
 *
 * Off until they ask for it, and off stops it — not pauses it. It spends money
 * on their account and mails them, so it is theirs to control and the copy says
 * exactly what it will do, how often, and where the email goes.
 */
export default function ScheduleToggle({ set, engine, plan, email }: {
  /** The set the run used. A one-off run with no saved set has nothing to repeat. */
  set: { id: string; name: string; domain: string } | null;
  engine: 'openai' | 'gemini';
  plan: 'free' | 'pro';
  email?: string;
}): JSX.Element | null {
  if (!set) return null;
  return (
    <div className="w-full border border-warm-dark-2 bg-warm-dark-2/20 rounded-xl p-4">
      <p className="text-text-primary">Re-check &ldquo;{set.name}&rdquo; automatically</p>
      <p className="text-sm text-text-secondary mt-1 mb-3">
        The same questions, re-asked on a schedule{email ? <>, with an email to {email}</> : null} saying which
        questions you started winning and which you lost. Weekly is plenty: off-site changes take weeks to show.
        Each question set has its own schedule.
      </p>
      <SetSchedule set={set} plan={plan} defaultEngine={engine} />
    </div>
  );
}
